// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","banner":"Header_banner__Amud4"};